// extracted by mini-css-extract-plugin
module.exports = {"block":"PlayerNewsModule_block__2jlhL","footer":"PlayerNewsModule_footer__9MEBZ","articles":"PlayerNewsModule_articles__FeE_9","noNews":"PlayerNewsModule_noNews__E7BiM"};